/**
 * @description 判断值是否存在，undefined、null、NaN为不存在
 * @param value
 * @returns
 */
const isExist = (value: any): boolean =>
  value !== undefined && value !== null && !Number.isNaN(value);

export default isExist;
